import { render, staticRenderFns } from "./form-checked-package.vue?vue&type=template&id=36f3be53&"
import script from "./form-checked-package.vue?vue&type=script&lang=js&"
export * from "./form-checked-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports